import { useTranslations } from "next-intl";

import IconDownload from "@/icons/content/media/download.svg";
import IconMap from "@/icons/map.svg";
import Button from "@/ui/Common/Button";
import { cn } from "@/utils/cn";

interface ObjectDetailUtilitiesProps {
  className?: string;
}

export function ObjectDetailUtilities({
  className,
}: ObjectDetailUtilitiesProps) {
  const t = useTranslations();

  return (
    <div
      className={cn(
        "flex flex-col md:flex-row gap-[1rem] md:gap-[2rem]",
        className,
      )}
    >
      <Button
        disabled
        type={"white"}
        className="w-full h-[5.4rem] justify-center"
      >
        <div className="space-x-[1rem] flex items-center md:px-[3rem]">
          <IconMap className={"icon"} />
          <span>{t("View on map")}</span>
        </div>
      </Button>
      <Button
        disabled
        type={"white"}
        className="w-full h-[5.4rem] justify-center"
      >
        <div className="space-x-[1rem] flex items-center md:px-[3rem]">
          <IconDownload className={"icon"} />
          <span>{t("Download PDF")}</span>
        </div>
      </Button>
    </div>
  );
}
